import React from 'react';
import { observer } from 'mobx-react-lite';
import { SectionTab } from 'polotno/side-panel';
import { Images } from './images';

import * as api from '../api';

export const InspirationPanel = observer(({ store }) => {
  return (
    <div style={{ height: '100%', overflow: 'auto', paddingRight: '3px' }}>
      <Images
        store={store}
        api={api.ASSETS_API + '?artboardSection=inspiration'}
      />
    </div>
  );
});

export const InspirationSection = {
  name: 'Inspiration',
  Tab: (props) => (
    <SectionTab name="Inspiration" {...props}>
      <img
        src={process.env.PUBLIC_URL + '/icons/inspiration.svg'}
        alt="Inspiration"
        style={{ width: '25px' }}
      />
    </SectionTab>
  ),
  Panel: InspirationPanel,
};
